const DOWN_KEYS = new Set(['ArrowDown', 'PageDown', 'End', ' ']);

export function isDownGesture(e: WheelEvent | KeyboardEvent): boolean {
  return e instanceof WheelEvent ? e.deltaY > 0 : DOWN_KEYS.has(e.key);
}
